import { css } from '@emotion/react';
import ProfilePicture from 'org_level_profile/components/profile-picture';
import { doubleSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import { hexToRgbaString, lowTide } from 'styles/global_defaults/colors';
import useViewedSubmission from './use-viewed-submission';

type LearnerChatProps = {
  content: string;
};

const styles = css`
  justify-content: flex-end;
  .learner-chat-bubble {
    background-color: ${hexToRgbaString(lowTide, 0.4)};
    border-radius: ${standardSpacing}px;
    min-height: 45px;
    max-width: 75%;
  }
`;

const LearnerChat = (props: LearnerChatProps) => {
  const { content } = props;
  const { profile } = useViewedSubmission();

  return (
    <div css={styles} className='d-flex'>
      <div className='learner-chat-bubble py-2 px-4 d-flex align-items-center'>
        <p className='mb-0'>{content}</p>
      </div>
      <div className='ml-2'>
        <ProfilePicture
          profile={profile}
          isRound
          size={doubleSpacing}
        />
      </div>
    </div>
  );
};

export default LearnerChat;
